import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AdminService } from 'src/app/pages/admin/services/admin.service';
@Component({
	selector: 'app-send-bulletin-email-modal',
	templateUrl: './send-bulletin-email-modal.component.html',
	styleUrls: ['./send-bulletin-email-modal.component.css']
})
export class SendBulletinEmailModalComponent {
	@Input() bulletin: { [key: string]: any };
	
	constructor(private ngbActiveModal: NgbActiveModal, private adminService: AdminService) { }

	sendClicked() {
		this.adminService.bulletinSendPendingReminder(this.bulletin.BulletinID).then((response: any) => {
			if (response.success)
				this.ngbActiveModal.close('true');
			else
				this.ngbActiveModal.close('false');
		});
	};

	cancelClicked() {
		this.ngbActiveModal.dismiss();
	};

}
